import React, { FunctionComponent } from 'react'
import { Modal, Tabs } from 'antd'
import Markdown from 'react-markdown'
import type { TabsProps } from 'antd';

import { markdown as markdown205 } from './logs/2.0.5.md'

const markdown = {
  '2.0.5': markdown205
}

interface IProps {
  open: boolean
  setOpen: (open: boolean) => void
}

const ChangeLog: FunctionComponent<any> = (props: IProps) => {
  const { open, setOpen } = props

  const items: TabsProps['items'] = Object.keys(markdown).map((key: string) => {
    const content = markdown[key]
    return {
      key,
      label: key,
      children: <Markdown>{content}</Markdown>
    }
  })

  return (
    <Modal open={open} onClose={() => setOpen(false)} onCancel={() => setOpen(false)} footer={null}>
      <Tabs
        defaultActiveKey={Object.keys(items)[0]}
        items={items}
      />
    </Modal>
  )
}

export default ChangeLog
